<template>
  <div>
    <v-flex xs12>
      <SurgeryListComponent
        :value="surgeryDiagnosis"
        @input="decompressDiagnosis($event)"
        name="Diagnóstico"
        singularName="Diagnóstico"
        :singleSelect="true"
        :orm="SurgeryDiagnosisOrm"
        :surgeryDiagnosisOther="surgeryDiagnosisOther"
        :anatomicalRegions="anatomicalRegions"
        :region="region"
      />
    </v-flex>
    <v-flex xs12 v-if="value === 'other'">
      <v-autocomplete
        :items="anatomicalRegions"
        label="Região anatómica"
        item-text="label"
        item-value="id"
        :value="region"
        @input="$emit('update:region', $event)"
      />
    </v-flex>
    <v-flex xs12 v-if="value === 'other'">
      <HintField
        componentId="surgeryDiagnosisOther"
        label="Diagnóstico (texto livre)"
        :value="surgeryDiagnosisOther"
        @input="$emit('update:surgeryDiagnosisOther', $event)"
      />
    </v-flex>
    <v-flex xs12>
      <v-select
        :value="malignancy"
        clearable
        label="Classificação"
        :items="malignancyOptions"
        item-text="name"
        item-value="id"
        no-data-text="Seleccione um diagnóstico primeiro"
        @change="$emit('update:malignancy', $event)"
        @click:clear="$emit('update:malignancy', '')"
      />
    </v-flex>
  </div>
</template>
<script>
import SurgeryListComponent from './SurgeryListComponent'
import {
  GeneralSurgery,
  SurgeryDiagnosis as SurgeryDiagnosisOrm
} from '@/models/GeneralSurgery'
import HintField from './HintField'

export default {
  components: { SurgeryListComponent, HintField },
  props: {
    value: { type: String, default: '' },
    surgeryDiagnosisOther: { type: String },
    qualifiers: { type: Array, default: () => [] },
    region: { type: String },
    malignancy: { type: String, default: '' }
  },
  data() {
    return {
      SurgeryDiagnosisOrm: SurgeryDiagnosisOrm,
      malignancyOptions: []
    }
  },
  computed: {
    surgeryDiagnosis() {
      return this.value
        ? [
            {
              id: this.value,
              qualifiers: this.qualifiers
            }
          ]
        : []
    },
    anatomicalRegions() {
      const tree = GeneralSurgery.query().first().organTree
      return tree.flatMap(n => (n.children ? [...n.children] : [n]))
    }
  },
  methods: {
    decompressDiagnosis(diagnosis) {
      let diagnosisId = ''
      let diagnosisQualifiers = []
      let regionId = ''
      let malignancyOpts = []

      if (diagnosis && diagnosis.length > 0) {
        diagnosisId = diagnosis[0].id
        diagnosisQualifiers = diagnosis[0].qualifiers

        let diagnosisObj = this.SurgeryDiagnosisOrm.query()
          .where('id', diagnosisId)
          .with('malignancy')
          .get()[0]
        regionId = diagnosisObj.region
        malignancyOpts = diagnosisObj.malignancy || []
      }

      this.malignancyOptions = malignancyOpts
      this.$emit('input', diagnosisId)
      this.$emit('update:qualifiers', diagnosisQualifiers)
      this.$emit('update:region', regionId)
      this.$emit('update:surgeryDiagnosisOther', null)

      //if only one option, default it
      this.$emit(
        'update:malignancy',
        malignancyOpts.length === 1 ? malignancyOpts[0].id : ''
      )
    }
  },
  created() {
    // load malignancy options
    if (this.value) {
      this.malignancyOptions =
        this.SurgeryDiagnosisOrm.query()
          .where('id', this.value)
          .with('malignancy')
          .get()[0].malignancy || []
    }
  }
}
</script>
